const Layout = r => require(['@/pages/PageLayout'], r);
const Home = r => require(["@/pages/new-home/index"], r);
const Tutorial = r => require(["@/pages/new-home/tutorial"], r);

export default {
  path: "/home",
  component: Layout,
  meta: { auth: "Home" },
  redirect: "/home/index",
  children: [
    {
      path: "/home/index",
      meta: { auth: "Home" , checkAuth: true },
      name: "index",
      component: Home
    },
    {
      path: "/home/tutorial",
      meta: { auth: false },
      name: "tutorial",
      component: Tutorial
    }
  ]
};
